import { useContext, useEffect, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service"
import { AppSpan, AppText, Circle, CustomContainer, FlexColumn, FlexRow, GridContainer, ScreenTitle } from "src/style"
import RatingIcon from 'src/assets/svg/settings-rate-acct-officer'
import { FiChevronRight } from "react-icons/fi"
import { RateAccountOfficerD2, ChangeAccountOfficer, AppCenterPopupPlusD2, Portal } from "src/component"

export const AccountOfficerD2: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const {notifier} = useContext(VisibilityContext)
    const [accountOfficer, setAccountOfficer] = useState<any>(null)
    const [view, setView] = useState('account-officer')

    useEffect(() => {
        handleFetchAccountOfficer()
    }, [])

    async function handleFetchAccountOfficer () {
        const response = await API.getAccountOfficer()
        if (response) setAccountOfficer(response)
    }

    return (
        <Portal>
            { view === 'account-officer' &&
                <AppCenterPopupPlusD2
                    title='Account Officer' 
                    height='56' overflow='hidden'
                    contentHeight='56' zIndex='6'
                    maxHeight='85'
                    close={close} 
                >
                    <ScreenTitle 
                        textSize="2" fontWeight="600"
                        color="#211121" bottomMargin="2.5"
                        className="module-row-title"
                    >
                        Account Officer
                    </ScreenTitle>
                    <GridContainer>
                        <Circle 
                            size="15.3" overflow="hidden" radius="45"
                            bgColor='#0D968F' bottomMargin="1.5"
                        >
                            <AppText textSize='6' fontWeight='600' color='#ffffff'>
                                {accountOfficer?.details?.name && accountOfficer?.details?.name[0]}
                            </AppText>
                        </Circle>
                        <FlexColumn padding="1.5">
                            <AppText 
                                fontWeight="500" color="#101828" 
                                fontFamily="Gilmer-Semi-Bold"
                                textSize="1.8"
                            >
                                {accountOfficer?.details?.name}
                            </AppText>
                            <AppText 
                                fontWeight="500" color="#101828" 
                                fontFamily="Gilmer-Semi-Bold" topMargin="1.5"
                            >
                                {accountOfficer?.details?.email}
                            </AppText>
                            <AppText 
                                fontWeight="500" color="#101828" 
                                fontFamily="Gilmer-Semi-Bold" topMargin="1.5"
                            >
                                {accountOfficer?.details?.phoneNumber}
                            </AppText>
                        </FlexColumn>

                        <CustomContainer topMargin="3">
                            <GridContainer 
                                minHeight='7.2' rightPadding='1'
                                topPadding='0.5' bottomPadding='0.5'
                                className='settings-item-container'
                                onClick={() => setView('rate-acct-officer')}
                            >
                                <FlexRow justifyContent='space-between' gap='1.5'>
                                    <FlexRow width='auto' sizeUnit='' gap='1.5'>
                                        <RatingIcon style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  />
                                        <CustomContainer width='auto' sizeUnit=''>
                                            <AppSpan fontWeight='600' color='#101828' cursor="pointer">Rate Account Officer</AppSpan>
                                            <AppText color='#667085' cursor="pointer">Provide valuable feedback by rating your Account Officer's assistance</AppText>
                                        </CustomContainer>
                                    </FlexRow>
                                    <FiChevronRight 
                                        style={{fontSize: '1.7rem', color: '#667085', flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                    />
                                </FlexRow>
                            </GridContainer>
                        </CustomContainer>
                    </GridContainer>
                </AppCenterPopupPlusD2>
            }
            { view === 'rate-acct-officer' &&
                <Portal forcePortal>
                    <RateAccountOfficerD2
                        close={() => setView('account-officer')}
                        data={accountOfficer}
                    />
                </Portal>
            }
            { view === 'request-change' &&
                <Portal forcePortal>
                    <ChangeAccountOfficer
                        close={() => setView('')} 
                        back={() => setView('account-officer')} 
                    />
                </Portal>
            }
        </Portal>
    )
}